import * as React from 'react'
import { useSelector } from 'react-redux'
import { selectAllLeads } from '@user/store/lead'
import { LeadListView } from './LeadListView'
import { LeadListProviderProps } from './typings'
import { useGetColumnData } from './useGetColumnData'

export function LeadListProvider(props: LeadListProviderProps) {
  const { loading: rowsLoading, page, ...rest } = props
  const rows = useSelector(selectAllLeads)
  const { loading: colsLoading, columns, columnVisibility } = useGetColumnData()

  return (
    <LeadListView
      {...rest}
      page={colsLoading ? 1 : page}
      loading={rowsLoading || colsLoading}
      columns={colsLoading ? [] : columns}
      columnVisibility={columnVisibility}
      rows={colsLoading ? [] : rows}
    />
  )
}
